export class FindAllProjectsError {
  public static readonly type = '[User/Projects] FindAllProjectsError';
  constructor(public readonly error: Error) {}
}
